import React, { FC } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

// models
import { AudienceMainModel } from '../../models/audience.model';

interface FormulaAudienceHoverCardProps {
    audience: AudienceMainModel;
}
const FormulaAudienceHoverCard: FC<
    React.PropsWithChildren<FormulaAudienceHoverCardProps>
> = ({ audience }) => {
    return (
        <Container>
            {audience.filters.map((item) => (
                <Box key={item.id}>
                    <TextBox>
                        <Text>{item.attribute.attribute_name}</Text>
                    </TextBox>
                    <TextBox>
                        <Text>{item.operator.display_name}</Text>
                    </TextBox>
                    <TextBox isValue>
                        <Text isValue>{item.value}</Text>
                    </TextBox>
                </Box>
            ))}
            {audience.description && (
                <div>
                    <TextLabel>Description</TextLabel>
                    <Box>
                        <TextBox>
                            <Text>{audience.description}</Text>
                        </TextBox>
                    </Box>
                </div>
            )}
        </Container>
    );
};
const Container = styled.div(() => ({
    minWidth: 300,
    maxWidth: 500,
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing(2),
    backgroundColor: aampeTheme.colors.white,
    padding: aampeTheme.spacing(2, 1),
    boxShadow:
        '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
}));

const Box = styled.div(() => ({
    width: '100%',
    padding: aampeTheme.spacing(1, 2),
    display: 'flex',
    gap: aampeTheme.spacing(1),
    border: `1px solid ${aampeTheme.colors.solidWG02}`,
    borderRadius: aampeTheme.borderRadius.default,
}));

const TextLabel = styled.span(() => ({
    color: aampeTheme.colors.gray600,
}));

const TextBox = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'isValue',
})<{ isValue?: boolean }>(({ isValue }) => ({
    overflow: 'auto',
    padding: aampeTheme.spacing(1),
    backgroundColor: isValue
        ? aampeTheme.colors.bordersWG01
        : aampeTheme.colors.backgroundWG01,
    borderRadius: aampeTheme.borderRadius.default,
}));

const Text = styled.span.withConfig({
    shouldForwardProp: (prop) => prop !== 'isValue',
})<{ isValue?: boolean }>(({ isValue }) => ({
    color: isValue ? aampeTheme.colors.gray600 : aampeTheme.colors.neutral09,
}));

export default FormulaAudienceHoverCard;
